<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">할인차량관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">할인차량 관리</p>
          <ul class="depth">
            <li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
            <li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">할인차량 등록</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                할인차량 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 60px" />
                <col style="width: 35%" />
                <col style="width: 15%; min-width: 60px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사용자명</th>
                  <td colspan="3">
                    <input type="text" title="사용자명 입력" class="md" v-model="carOwnerNm" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td colspan="3">
                    <div class="flex">
                      <input
                        @keyup.enter="duplicateCheck"
                        :readonly="dupChk"
                        type="text"
                        title="사용자명 입력"
                        class="md"
                        v-model="carNo"
                      />
                      <button type="button" class="btn gray" @click="duplicateCheck">중복확인</button>
                    </div>
                    <div class="error" v-if="!$v.carNo.required">필수 입력란입니다.</div>
                    <div class="error" v-if="!$v.carNo.carNoCheck">차량번호 형식에 맞지 않습니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인유형</th>
                  <td>
                    <select v-model="discountCd" title="할인유형 선택">
                      <option
                        v-for="(item, index) in discountList"
                        :key="index"
                        :value="{ id: item.code, text: item.codeNm }"
                      >
                        {{ item.codeNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">할인기간</th>
                  <td colspan="3">
                    <date-picker :propsDate="searchDate" class="middle"></date-picker>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비고</th>
                  <td colspan="3">
                    <input v-model="note" type="text" title="비고 입력" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea">
          <!-- <button type="button" class="btn border" @click="$router.push('discountvehicle')">목록</button> -->
          <button type="button" class="btn gray" @click="$router.push('discountvehicle')">취소</button>
          <button type="button" class="btn blue" @click="insertAction">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import moment from 'moment';
import { required, helpers, or } from 'vuelidate/lib/validators';
const carNoRegex = helpers.regex('carNoRegex', /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegex2 = helpers.regex('carNoRegex', /^\s*([가-히]{3}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegexDipl = helpers.regex(
  'carNoRegexDipl',
  /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi,
);

export default {
  data() {
    return {
      parkingList: [],
      discountList: [],
      discountCd: '',

      carOwnerNm: '',
      carNo: '',
      discountRate: '',
      note: '',
      
      dupChk: false,
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
    };
  },

  validations: {
    carOwnerNm: {
      required,
    },
    carNo: {
      required,
      carNoCheck: or(carNoRegex, carNoRegexDipl, carNoRegex2),
    },
  },

  components: {
    DatePicker,
  },

  mounted() {
    this.findParkingList();
    this.findDiscountListList();
  },

  methods: {
    async findParkingList() {
      const res = await axios('get', '/api/parking/map.json');
      this.parkingList = res.data.parkingMapList;
    },

    async findDiscountListList() {
      const res = await axios('get', '/api/prepay/getDiscountList.json');
      this.discountList = res.data.discountList;
    },

    async duplicateCheck() {
      if (!this.$v.carNo.carNoCheck || this.carNo == '') {
        alert('차량 형식에 맞게 입력해주세요.');
        return;
      }

      const apiParams = new FormData();
      apiParams.append('carNo', this.carNo.replace(/ /gi, ''));
      const res = await axios('post', '/api/admin/discount/carNoCheck.json', apiParams);
      const data = res.data.result.result.result;
      if (!data) {
        alert('이미 등록중인 차량입니다.');
      } else {
        this.dupChk = true;
        alert('등록 가능한 차량입니다.');
      }
    },

    async insertAction() {
      if (!this.$v.carNo.carNoCheck) {
        alert('차량 형식에 맞게 입력해주세요.');
        return;
      }

      const apiParams = new FormData();
      apiParams.append('carNo', this.carNo.replace(/ /gi, ''));
      apiParams.append('carOwnerNm', this.carOwnerNm);
      apiParams.append('discountCd', this.discountCd.id);
      apiParams.append('startDt', this.searchDate.startDate);
      apiParams.append('endDt', this.searchDate.endDate);
      apiParams.append('note', this.note);
      const res = await axios('post', '/api/admin/discount/insert.json', apiParams);
      if (res.data.resultVo.code == '00') {
        alert('등록 되었습니다!');
        this.$router.push('discountvehicle');
      }
    },
  },
};
</script>
